const SUPPORTED_SETTING_HIGHLIGHTS: Readonly<
  Record<string, readonly string[]>
> = {
  "customer_widget.appearance": ["customerWidget/general/widgetColor"],
  "support.live_chat_widget": [
    "customerWidget/general/hideWidgetAfterHours",
    "customerWidget/support/messagingHeadingText",
  ],
};

export function getSettingsFocusedSettingHref({
  groupId,
  href,
  settingId,
}: {
  groupId: string;
  href: string;
  settingId: string;
}): string {
  const baseUrl = "https://redo.local";
  const url = new URL(href, baseUrl);

  url.searchParams.delete("group");
  url.searchParams.delete("setting");
  url.searchParams.delete("highlight");
  url.hash = "";

  if (supportsSettingsHighlight(groupId, settingId)) {
    url.searchParams.set("group", groupId);
    url.searchParams.set("setting", settingId);
    url.searchParams.set("highlight", "both");
  }

  if (url.origin === baseUrl) {
    return `${url.pathname}${url.search}`;
  }

  return url.toString();
}

function supportsSettingsHighlight(
  groupId: string,
  settingId: string,
): boolean {
  return SUPPORTED_SETTING_HIGHLIGHTS[groupId]?.includes(settingId) ?? false;
}
